import axios from 'axios';

class nest {
  constructor(baseURL, context){
    this.context = context;
    this.baseURL = baseURL;
    this.token = null;
    this.config = {baseURL};
    let headers = {common: {}}
    if (context) {
      headers.common['context'] = context;
    }
    this.axios = new axios.create({baseURL, headers});
    this.isBusy = false;
    this.queue = [];
    this.debug = process.env.VUE_APP_DEBUG;

    let resetTokenAndRepeat = async (err) => {
      try {
        const { response: errorResponse } = err;

        const retry = new Promise(resolve => {
          this.queue.push(access_token => {
            errorResponse.config.headers.authorization = 'bearer ' + access_token;
            resolve(axios(errorResponse.config).catch((err)=>{
              if (err.response && err.response.status == '401') {
                console.log('Access has expired, Logging out.', err.response.status);
                window.mbStore.commit('account/WIPE_CONTEXTS');
              }
            }));
          });
        });

        if (!this.isBusy) {
          this.isBusy = true;
          const freshToken = await this.getFreshToken()
          if (!freshToken) {
            // TODO: log them out!
            return Promise.reject('Unable to aquire a fresh token');
          }
          this.token = freshToken;
          this.setAuth(freshToken);
          this.isBusy = false;
          this.queue.forEach(callback => callback(freshToken));
          this.queue = [];
        }
        return retry;
      } catch (err) {
        return Promise.reject(err)
      }

    }

    let responseError = function(err){
      if (err.response && err.response.status == '401') {
        return resetTokenAndRepeat(err)
      }
      return Promise.reject(err)
    }
    this.axios.interceptors.response.use(null, responseError)
  }
  
  status(){
    return {
      auth: this.axios.defaults.headers.common.authorization,
      refresh: this.axios.defaults.headers.common.refresh,
      refresh_token: this.axios.defaults.headers.common.refresh_token,
      headers: this.axios.defaults.headers,
      context: this.axios.defaults.headers.common.context,
      shopURI: this.axios.defaults.headers.common.shopURI
    };
  }

  async getFreshToken(){
    let {data} = await this.axios.get('/auth/refresh_token');
    window.mbStore.commit('account/SET_TOKEN', data);
    window.mbStore.dispatch('account/INIT_AUTH');
    return data.token;
  }

  logout(){
    window.mbStore.commit('account/WIPE_CONTEXTS');
    delete this.config.authorization
    delete this.config.refresh
  }

  setAuth(token, refresh, context, shopURI){
    if (this.debug) {
      console.log('nest_api setAuth', {token, refresh, context, shopURI});
    }
    let store = this.axios.defaults.headers.common;
    if(token) store['authorization'] = `bearer ${token}`;
    if(refresh) store['refresh'] = refresh;
    if(context) store['context'] = context;
    if(shopURI) store['shopURI'] = shopURI;
    this.config = {...this.config, ...store};
    this.token = token;
  }

  async get(route, options){
    let {data} = await this.axios.get(route, options)
    return data
  }
  async post(route, params){
    let {data} = await this.axios.post(route, params)
    return data
  }
  async put(route, params){
    let {data} = await this.axios.put(route, params)
    return data
  }
  async delete(route, params){
    let {data} = await this.axios.delete(route, params)
    return data
  }
  async loginWithToken(context, token){
    let {data} =  await this.axios({
      method: 'get',
      url: '/auth/token_login',
      headers: {
        authorization: `bearer ${token}`,
        token_login: true,
        context
      }
    });
    return data;
  }
}

export default nest